(()=>{
'use strict';
if(window.FDHomeTeamCycle)return;window.FDHomeTeamCycle=true;
const SWITCH_MS=3000;
let movingUntil=0;
const pauseForGesture=()=>{movingUntil=Date.now()+700;};
window.addEventListener('scroll',pauseForGesture,{passive:true,capture:true});
const available=card=>visible.has(card)&&!document.hidden&&Date.now()>=movingUntil;
const groups={
'real-madrid':['maillot-real-madrid-y254094935','maillot-real-madrid-domicile-26-27','maillot-real-madrid-third-26-27'],
'fc-barcelone':['maillot-fc-barcelone-third-26-27','maillot-fc-barcelone-exterieur-26-27','maillot-fc-barcelone-y254094897'],
'psg':['maillot-psg-y254095704','maillot-psg-domicile-26-27'],
'marseille':['maillot-marseille-y254095360','maillot-marseille-y254094231','maillot-marseille-domicile-26-27'],
'juventus':['maillot-juventus-y254094960','maillot-juventus-y254093370','maillot-juventus-y254096968'],
'manchester-city':['maillot-manchester-city-domicile-26-27','maillot-manchester-city-y254095617','maillot-manchester-city-y254094914'],
'liverpool':['maillot-liverpool-y254095473','maillot-liverpool-y254096496','maillot-liverpool-y254096892'],
'arsenal':['maillot-arsenal-exterieur-26-27','maillot-arsenal-domicile-26-27','maillot-arsenal-third-26-27'],
'bayern-munich':['maillot-bayern-munich-y254096203','maillot-bayern-munich-domicile-26-27','maillot-bayern-munich-y254094268'],
'ac-milan':['maillot-ac-milan-exterieur-26-27','maillot-ac-milan-y254096147','maillot-ac-milan-third-26-27'],
'manchester-united':['maillot-manchester-united-y254093940','maillot-manchester-united-domicile-26-27','maillot-manchester-united-y254094879','maillot-manchester-united-y254094707'],
'chelsea':['maillot-chelsea-exterieur-26-27','maillot-chelsea-domicile-26-27','maillot-chelsea-y254094587']
};
const aliases=[
['real-madrid','real madrid'],['fc-barcelone','fc barcelone'],['psg','psg'],['marseille','marseille'],
['juventus','juventus'],['manchester-city','manchester city'],['liverpool','liverpool'],['arsenal','arsenal'],
['bayern-munich','bayern munich'],['ac-milan','ac milan'],['manchester-united','manchester united'],['chelsea','chelsea']
];
const cache=new Map(),visible=new WeakSet(),state=new WeakMap();
const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
function team(card){const hay=norm((card.dataset.fdTags||'')+' '+(card.dataset.fdTitle||''));return aliases.find(([,name])=>hay.includes(name))?.[0]||''}
function current(card){const href=card.querySelector('.fdpc-image-link')?.getAttribute('href')||'';return href.split('/products/')[1]?.split(/[?#]/)[0]||''}
function versionLabel(title,index,total){
 const t=norm(title);
 if(/domicile|home/.test(t))return 'DOMICILE';
 if(/exterieur|away/.test(t))return 'EXTÉRIEUR';
 if(/third|troisieme|3e/.test(t))return 'THIRD';
 if(/fourth|4e/.test(t))return 'FOURTH';
 return 'VERSION '+(index+1)+'/'+total;
}
function ensureUi(card){
 const media=card.querySelector('.fdpc-media');if(!media)return null;
 let ui=card.querySelector(':scope > .fd-team-cycle-ui');
 if(!ui){
   ui=document.createElement('div');ui.className='fd-team-cycle-ui';ui.setAttribute('aria-hidden','true');
   ui.innerHTML='<div class="fd-team-cycle-track"><i></i></div><div class="fd-team-cycle-meta"><strong data-fd-cycle-label>VERSION</strong><span data-fd-cycle-count>AUTO</span></div>';
   media.insertAdjacentElement('afterend',ui);
 }
 return ui;
}
function updateUi(card,title,index,total){
 const ui=ensureUi(card);if(!ui)return;
 const label=ui.querySelector('[data-fd-cycle-label]'),count=ui.querySelector('[data-fd-cycle-count]');
 if(label)label.textContent=versionLabel(title,index,total);
 if(count)count.textContent=(index+1)+'/'+total+' · AUTO';
}
function restartProgress(card){
 card.classList.remove('fd-team-cycle--running');
 void card.offsetWidth;
 if(visible.has(card)&&!document.hidden)card.classList.add('fd-team-cycle--running');
}
async function load(handle){
 if(cache.has(handle))return cache.get(handle);
 const p=fetch('/products/'+encodeURIComponent(handle)+'.js',{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw Error('product');return r.json()});
 cache.set(handle,p);return p;
}
function cardImage(src){const url=new URL(src,location.origin);url.searchParams.set('width','640');return url.href;}
function preloadImage(src){
 if(!src)return Promise.resolve();
 return new Promise(resolve=>{const img=new Image();img.onload=img.onerror=()=>resolve();img.src=cardImage(src);});
}
function money(cents){return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:window.Shopify?.currency?.active||'EUR'}).format(Number(cents||0)/100)}
async function apply(card,p,s){
 if(!p||!available(card))return;
 if(p.featured_image)await preloadImage(p.featured_image);
 if(!available(card))return;
 card.classList.add('fd-team-cycle--swapping');
 return new Promise(resolve=>setTimeout(()=>{
   if(!available(card)){card.classList.remove('fd-team-cycle--swapping');resolve();return;}
   const url=p.url||('/products/'+p.handle);
   card.dataset.fdTitle=p.title||'';
   card.dataset.fdTags=Array.isArray(p.tags)?p.tags.join(' '):(p.tags||'');
   card.dataset.fdCardTags=JSON.stringify(Array.isArray(p.tags)?p.tags:[]);
   card.querySelectorAll('.fdpc-image-link,.fdpc-name,.fdpc-plus').forEach(a=>a.href=url);
   const imageLink=card.querySelector('.fdpc-image-link');if(imageLink)imageLink.setAttribute('aria-label',p.title||'');
   const name=card.querySelector('.fdpc-name');if(name){name.textContent=p.title||'';name.setAttribute('aria-label',p.title||'')}
   const source=card.querySelector('.fdpc-source');if(source)source.textContent=p.title||'';
   const heart=card.querySelector('[data-fd-heart]');if(heart){heart.dataset.handle=p.handle||'';heart.setAttribute('aria-label','Garder en favoris : '+(p.title||''))}
   const img=card.querySelector('.fdpc-photo');
   if(img&&p.featured_image){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=cardImage(p.featured_image);img.alt=p.title||''}
   const price=card.querySelector('.fdpc-price');if(price&&Number.isFinite(Number(p.price)))price.textContent=money(p.price);
   const plus=card.querySelector('.fdpc-plus');if(plus)plus.setAttribute('aria-label','Voir le maillot : '+(p.title||''));
   updateUi(card,p.title||'',s.index,s.list.length);
   window.FDProductCards?.enhance?.(card);
   card.classList.remove('fd-team-cycle--swapping');
   restartProgress(card);resolve();
 },150));
}
function start(){
 const cards=[...document.querySelectorAll('.fdgc-wrap .fdgc-bsrow [data-fd-product-card]')];
 cards.forEach(card=>{
   const key=team(card),list=groups[key];if(!list?.length)return;
   let index=list.indexOf(current(card));if(index<0)index=0;
   const s={list,index,busy:false};state.set(card,s);
   updateUi(card,card.dataset.fdTitle||'',index,list.length);

 });
 const io=new IntersectionObserver(entries=>entries.forEach(entry=>{
   if(entry.isIntersecting){
     visible.add(entry.target);restartProgress(entry.target);
     const s=state.get(entry.target);
     if(s&&!document.hidden)load(s.list[(s.index+1)%s.list.length]).then(p=>preloadImage(p.featured_image)).catch(()=>{});
   }else{
     visible.delete(entry.target);entry.target.classList.remove('fd-team-cycle--running');
   }
 }),{rootMargin:'160px',threshold:.05});
 cards.forEach(card=>io.observe(card));
 setInterval(()=>{
   if(document.hidden||Date.now()<movingUntil)return;
   cards.forEach(async card=>{
     if(!visible.has(card))return;
     const s=state.get(card);if(!s||s.list.length<2||s.busy)return;
     s.busy=true;
     s.index=(s.index+1)%s.list.length;
     try{
       const p=await load(s.list[s.index]);
       await apply(card,p,s);
       const next=s.list[(s.index+1)%s.list.length];
       load(next).then(np=>preloadImage(np.featured_image)).catch(()=>{});
     }catch(_){restartProgress(card)}
     finally{s.busy=false}
   });
 },SWITCH_MS);
 document.addEventListener('visibilitychange',()=>{
   cards.forEach(card=>{
     if(document.hidden)card.classList.remove('fd-team-cycle--running');
     else if(visible.has(card))restartProgress(card);
   });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
